import { useApolloClient } from "@apollo/client";
import { useEffect, useState } from "react";
import { MessageHeader } from "components/NewMessageUtils/MessageHeader";
import {
  DoctorMSIpom,
  DoctorPatientMessagesDocument,
  DoctorPatientMessagesQuery,
  DoctorPatientMessagesQueryVariables,
} from "lib/graphql/megaSchema";

type Props = {
  content: string;
  patientId: string;
};

export const IpomProcedureMessage = ({ content, patientId }: Props) => {
  const [ipomProcedure, setIpomProcedure] = useState<DoctorMSIpom | null>(null);

  const client = useApolloClient();
  const getPatientCareRecord = (patientId: string) => {
    return client.query<
      DoctorPatientMessagesQuery,
      DoctorPatientMessagesQueryVariables
    >({
      query: DoctorPatientMessagesDocument,
      fetchPolicy: "no-cache",
      variables: {
        patientId,
      },
    });
  };

  useEffect(() => {
    if (content.startsWith("[cardiology-diagnostic-")) {
      const id = content.slice(23, -1);

      getPatientCareRecord(patientId).then((res) =>
        setIpomProcedure(
          res.data.doctorGetMessagesForPatient.find(
            (message) =>
              message.__typename === "DoctorMSIpom" && message.id === id,
          ) as DoctorMSIpom,
        ),
      );
    }
  }, []);

  if (!ipomProcedure) return null;

  return (
    <div className="calcContainer font-geologica relative mb-5 ml-0">
      <MessageHeader mine={false} />
      <div className="rounded-lg rounded-tl-none bg-jutro-new-warm-gray-50">
        <div className="font-paragraph-2 whitespace-pre-line break-words px-2 py-3 text-jutro-new-blue-950">
          Wysłano skierowanie na:{" "}
          <span className="font-bold">{ipomProcedure.data?.icd9?.name}</span>
        </div>
      </div>
    </div>
  );
};
